import React from "react";
import Lottie from "lottie-react";
import logoLoadingAnimation from "../assets/logo-loading.lottie.json";

export const Loading = () => {
  return (
    <div className="w-full flex justify-center">
        <div className="grid h-screen place-items-center">
        <div className="w-32 h-32 flex bg-black rounded">
            <Lottie animationData={logoLoadingAnimation} loop={true} />;
        </div>
        </div>
    </div>
  );
};
